import * as LocationService from '../services/location-service';

export function resetState(state) {
  return function (dispatch) {
    dispatch(reset(state));
  };
}

export function fetchLocations() {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await LocationService.list();
      dispatch(success('FETCH_LOCATIONS', response.data));
    } catch (err) {
      return dispatch(error('LOCATION_ERROR', err));
    }
  };
}

export function save(location) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await LocationService.save(location);
      return dispatch(success('ADD_LOCATION', response.data));
    } catch (err) {
      return dispatch(error('LOCATION_ERROR', err));
    }
  };
}

export function update(location) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await LocationService.update(location);
      return dispatch(success('UPDATE_LOCATION', response.data));
    } catch (err) {
      return dispatch(error('LOCATION_ERROR', err));
    }
  };
}

export function changeStatus(id) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await LocationService.changeStatus(id);
      return dispatch(success('UPDATE_LOCATION', response.data));
    } catch (err) {
      return dispatch(error('LOCATION_ERROR', err));
    }
  };
}

/* Search LOCATIONS */
export function search(searchParameters) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await LocationService.search(searchParameters);
      dispatch(success('SEARCH_LOCATIONS', response.data));
    } catch (err) {
      dispatch(error('LOCATION_ERROR', err));
    }
  };
}

function reset(type) {
  return {
    type: type,
  };
}

function process() {
  return {
    type: 'PROCESSING_LOCATION',
  };
}

function success(type, data) {
  return {
    type: type,
    payload: data,
  };
}
function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}